<h2 mat-dialog-title>{{ dialogTitle }}</h2>
<mat-dialog-content>
  <div class="file-upload">
    <input
      type="file"
      class="file-input"
      (change)="handleFileInput($event)"
      #fileUpload
      [disabled]="isDownloaded"
    />
    <button
      mat-flat-button
      type="button"
      (click)="fileUpload.click()"
      class="add-button"
      [ngClass]="{ 'add-button-disabled': isDownloaded || maxLength }"
      [class.spinner]="isDownloaded && !isRemoving"
      [disabled]="isDownloaded || maxLength"
    >
      Add
    </button>
  </div>
  <mat-action-row *ngIf="!addedFiles || addedFiles.length === 0">
    <p>No files</p>
  </mat-action-row>
  <div *ngIf="addedFiles.length >= 1" class="file-list">
    <mat-list>
      <mat-list-item *ngFor="let file of addedFiles; let i = index">
        <div class="file-list-item-row">
          <div class="file-list-item-title" (click)="downloadFile(file.id)">
            <span class="file-name"
              >{{ checkLength(file.originalFileName) }}
              <span
                class="pointer"
                *ngIf="file.originalFileName.length >= maxLengthFileTitle"
                matTooltip="{{ file.originalFileName }}"
                >(...)</span
              >
            </span>
          </div>
          <button
            mat-icon-button
            type="button"
            matTooltip="Remove file"
            (click)="removeFile(file.id)"
          >
            <mat-icon>delete_forever</mat-icon>
          </button>
        </div>
      </mat-list-item>
    </mat-list>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onClose()">Close</button>
</mat-dialog-actions>
